import React from 'react'
import InputSubDataDocsAdd from '../Inputs/InputSubDataDocsAdd'
import { Request } from '../../hooks/Request'
import Loading from '../Animation/Loading'
import { H2 } from '../Text'

export const DocsPerField = ({ procedure }) => {
    console.log(procedure)
    const { data: dataField, loading } = Request({
        urlApi: `/field/documentosSeccionL/detail`,
    })
    const field = { id: procedure.id, fieldId: dataField?.id, url: dataField?.url, permission: dataField?.details }
    if (!loading)
        return <Loading />
    return (
        <div>
            <H2>DOCUMENTOS DE LA SECCIÓN L</H2>
            <InputSubDataDocsAdd field={field} />
        </div>
    )
}
